// Thin wrapper around the gtag.js snippet loaded in public/index.html
// (GA4 property G-YRV9QB351N). `window.gtag` may not exist yet on the very
// first call (script loads async) or at all (an ad-blocker stripped it) —
// every export here no-ops safely in either case rather than throwing.
const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

// Fired on every route change (see RouteTracker below) — GA4's own
// send_page_view is switched off in index.html specifically so this is the
// only place a pageview gets recorded, covering the SPA's client-side
// navigations that a plain page-load-only pageview would miss entirely.
export const trackPageview = (path, title) => {
  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

// For anything more specific than a pageview — e.g. "shipment created",
// "invoice paid". `params` is optional, GA4-shaped event parameters.
export const trackEvent = (name, params = {}) => {
  gtag("event", name, params);
};
